import { Product } from "shared/types/product/Product";
import { Variant } from "shared/types/product/Variant";
import { ITEM_NAME } from 'helpers/constants/attributes';
import { localeCountryKey } from "helpers/constants/localeMapping";
import OgTagsSchema from "../../og-tags-schema";

interface ProductSchemaProps {
  product: Product;
  variant: Variant;
  variantUrl: string;
  locale: string;
}

const ProductSchema: React.FC<ProductSchemaProps> = ({ product, variant, variantUrl, locale }) => {
  const schemaTag = `
    {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": "${typeof variant?.attributes?.[ITEM_NAME] === 'string' ? variant?.attributes?.[ITEM_NAME] : product?.name}",
      "image": "${variant.images?.[0] ?? ''}",
      "description": "${product.metaDescription || ''}",
      "brand": {
        "@type": "Brand",
        "name": "${variant?.attributes?.brand || ''}"
      },
      "sku": "${variant?.attributes?.['item-code']|| ''}",
      "offers": {
        "@type": "Offer",
        "url": "${variantUrl}",
        "priceCurrency": "${locale==localeCountryKey.au ? 'AUD' : 'NZD'}",
        "price": "${((variant.price?.centAmount as number) / 100).toFixed(2)}",
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition"
      }
    }
  `;

  return (
    <>
      <OgTagsSchema ogTitle={typeof variant?.attributes?.[ITEM_NAME] === 'string' ? variant?.attributes?.[ITEM_NAME] : product?.name} 
      ogDescription={product.metaDescription} ogUrl={variantUrl} ogType="product" ogImage={variant.images?.[0]} />
      <meta property="product:price:amount" content={((variant.price?.centAmount as number) / 100).toFixed(2)} />
      <meta property="product:price:currency" content={locale==localeCountryKey.au ? 'AUD' : 'NZD'} />
      <meta property="product:brand" content={variant?.attributes?.brand || ''} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaTag }} />
    </>
  );
};

export default ProductSchema;
